export default {
  // Featured collections on the landing page, shown above the full collection
  // list (the widget itself only renders on the root catalog). Entries are
  // collection IDs resolved against the STAC API; order is display order.
  // Title falls back to the localized "widgets.featured" phrase.
  'view-catalog-catalogs-start': [
    {
      id: 'Featured',
      props: {
        entities: [
          'anm-daily-grids',
          'sentinel-2-burn-scars-terramind-fire',
          'sentinel-1-rtc',
          'sentinel-2-l2a'
        ],
        view: 'cards'
      }
    }
  ]
};
